import initialState from '../initialState'

export function updateSharedUserDetails(state = initialState, action) {
  switch (action.type) {
    case 'SET_SHARED_USER_DETAILS':
      return Object.assign({}, state.sharedUserList, action.sharedUserList)
    default:
      return state
  }
}

export function updateSharedFolderDetails(
  state = initialState.sharedFolderDetails,
  action,
) {
  switch (action.type) {
    case 'SET_SHARED_FOLDER_DETAILS':
      return action.sharedFolderDetails
    default:
      return state
  }
}

export function updateSharedFolderPath(
  state = initialState.shareePath,
  action,
) {
  switch (action.type) {
    case 'SET_SHAREE_PATH':
      return action.shareePath
    default:
      return state
  }
}

export default {
  updateSharedUserDetails,
  updateSharedFolderDetails,
  updateSharedFolderPath,
}
